<template lang="html">
  <div class="">
    <Header :openTarget="'user/home?id=' + uid" />

    <div class="content" :style="{backgroundImage: 'url('+ personalCenterData.cover +')'}">
      <div class="introCon">
        <div class="information">
          <div class="topInfo">
            <img :src="personalCenterData.avatar" alt="" class="userHeader">
            <div class="uesrHotData">
              <p class="dataName">获赞</p>
              <p class="dataNum">{{personalCenterData.total_like_num}}</p>
            </div>
            <div class="uesrHotData focusOn">
              <p class="dataName">关注</p>
              <p class="dataNum">{{personalCenterData.following}}</p>
              <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + uid" />
            </div>
            <div class="uesrHotData">
              <p class="dataName">粉丝</p>
              <p class="dataNum">{{personalCenterData.follower}}</p>
              <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + uid" />
            </div>
          </div>
          <div class="conInfo">
            <p class="userName">{{personalCenterData.nickname || personalCenterData.username}}</p>
            <div class="attentionBtn">
              关注
              <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + uid" />
            </div>
          </div>
          <div class="bottomInfo">
            <div class="userAccount" v-if="userType == 2">
              <img src="../../assets/image/icon/tv.png" alt="">
              <p>{{ personalCenterData.official_title }}</p>
            </div>
            <div class="userAccount" v-else-if="userType == 1">
              <img src="../../assets/image/icon/pv.png" alt="">
              <p>{{ personalCenterData.official_title }}</p>
            </div>
            <p class="userIntroduce" v-show="personalCenterData.sightml">
              {{personalCenterData.sightml}}
            </p>
            <div class="relationCon" v-show="personalCenterData.relation_num">
              <p class="userRelation">
                <img src="@/assets/image/icon/iconNo3.png" alt="">
                <span class="relationTxt">已关联</span>
                <span class="relationNum">{{personalCenterData.relation_num}}个用户</span>
              </p>
            </div>
          </div>
        </div>
        
        <div class="informationMod">
          <ul class="tabTilte">
            <li class="tabMod" v-show="recommendShow" @click="cur = 0" :class="{active:cur == 0}">
              推荐
            </li>
            <li class="tabMod" v-show="videoShow" @click="cur = 1" :class="{active:cur == 1}">
              视频
            </li>
            <li class="tabMod" v-show="courseShow" @click="cur = 2" :class="{active:cur == 2}">
              课程
            </li>
            <li class="tabMod" v-show="productShow" @click="cur = 3" :class="{active:cur == 3}">
              产品
            </li>
            <li class="tabMod" v-show="circleShow" @click="cur = 4" :class="{active:cur == 4}">
              圈子
            </li>
            <li class="tabMod" v-show="facultySubjectShow" @click="cur = 5" :class="{active:cur == 5}">
              院系学科
            </li>
            <li class="tabMod" v-show="facultyAchievementShow" @click="cur = 6" :class="{active:cur == 6}">
              科研成果
            </li>
            <li class="tabMod" v-show="facultyTeacherShow" @click="cur = 7" :class="{active:cur == 7}">
              院系老师
            </li>
            <li class="tabMod" v-show="interactShow" @click="cur = 8" :class="{active:cur == 8}">
              互动
            </li>
            <li class="tabMod" v-show="recruitShow" @click="cur = 9" :class="{active:cur == 9}">
              校招
            </li>
            <li class="tabMod" v-show="answerShow" @click="cur = 10" :class="{active:cur == 10}">
              答疑
            </li>
          </ul>
          
          <div class="tabContent">
            <div v-show="cur == 0">
              <v-recommend :userId='uid' />
            </div>
            <div v-show="cur == 1">
              <v-video :userId='uid' />
            </div>
            <div v-show="cur == 2">
              <v-course :userId='uid' @length="courselist" />
            </div>
            <div v-show="cur == 3">
              <v-product :userId='uid' />
            </div>
            <div v-show="cur == 4">
              <v-circle :userId='uid' />
            </div>
            <div  v-show="cur == 5">
              <v-subject :userId='uid' />
            </div>
            <div v-show="cur == 6">
              <v-achievement :userId='uid'/>
            </div>
            <div v-show="cur == 7">
              <v-teacher :userId='uid'/>
            </div>
            <div v-show="cur == 8">
              <v-interaction :userId='uid'/>
            </div>
            <div v-show="cur == 9">
              <v-recruit :userId='uid'/>
            </div>
            <div v-show="cur == 10">
              <v-answer :userId='uid'/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="callAppIcon" v-show="callApp">
      <img src="../../assets/image/icon/ic_button.png" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'user/home?id=' + uid" />
    </div>

    <div class="topIcon" v-show="topPost">
      <img src="../../assets/image/icon/ic_top.png" alt="" @click="getTopBtn">
    </div>
  </div>
</template>

<script>
  import Header from '@/components/HeadModule';
  import Recommend from './components/Recommend';
  import Course from './components/Course';
  import Video from './components/Video';
  import Product from './components/Product';
  import Circle from './components/Circle';
  import CollegeSubject from './components/CollegeSubject';
  import CollegeAchievement from './components/CollegeAchievement';
  import CollegeTeacher from './components/CollegeTeacher';
  import CollegeInteraction from './components/CollegeInteraction';
  import Recruit from './components/Recruit';
  import Answer from './components/Answer';
  
  import WxOpenTag from '@/components/WxOpenTag';
  import WxShare from '@/utils/wxshare';

  export default {
    data() {
      return {
        uid: this.$route.query.uid || '',
        cur: 1,
        // 推荐
        recommendShow: false,
        // 视频
        videoShow: false,
        // 课程
        courseShow: false,
        // 产品
        productShow: false,
        // 圈子
        circleShow: false,
        // 院系学科
        facultySubjectShow: false,
        // 科研成果
        facultyAchievementShow: false,
        // 院系老师
        facultyTeacherShow: false,
        // 互动
        interactShow: false,
        // 校招
        recruitShow: false,
        // 答疑
        answerShow: false,
        personalCenterData: [],
        userType: '',
        videoList: [],
        callApp: false,
        topPost: false,
      }
    },

    components: {
      Header,
      'v-recommend': Recommend,
      'v-course': Course,
      'v-video': Video,
      'v-product': Product,
      'v-circle': Circle,
      'v-subject': CollegeSubject,
      'v-achievement': CollegeAchievement,
      'v-teacher': CollegeTeacher,
      'v-interaction': CollegeInteraction,
      'v-recruit': Recruit,
      'v-answer': Answer,
      WxOpenTag,
    },

    created() {

    },

    mounted() {
      this.wxshare = new WxShare();
      this.init();
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('scroll', this.getTopPost);
    },
    methods: {
      init() {
        this.getUserDetails();
      },

      getUserDetails() {
        this.$http({
          url: '/User/userDetails',
          method: 'get',
          params: {
            uid: this.uid,
          },
        }).then(res => {
          if (res.code >= 0) {
            this.personalCenterData = res.data;
            this.userType = res.data.mp_type;

            // 未装修过
            if (this.personalCenterData.is_update_renovation == 0) {
              // 普通号
              if (this.userType == 0) {
                this.videoShow = true;
                this.circleShow = true;
                this.getCur(1);
              }
              // 高校号 & 企业号
              if (this.userType == 1) {
                if (this.personalCenterData.certification_type == 2) {
                  this.facultySubjectShow = true;
                  this.facultyAchievementShow = true;
                  this.facultyTeacherShow = true;
                  this.interactShow = true;
                  // 校招
                  this.recruitShow = true;
                  this.getCur(5);
                } else {
                  this.videoShow = true;
                  this.productShow = true;
                  this.circleShow = true;
                  this.interactShow = true;
                  this.recruitShow = true;
                  // 校招
                  this.recruitShow = true;
                  this.getCur(1);
                }
              }
              // 专家号 
              if (this.userType == 2) {
                this.videoShow = true;
                this.circleShow = true;
                this.interactShow = true;
                // 答疑
                if(this.personalCenterData.is_open_qa){
                  this.answerShow = true;
                }               
                this.getCur(1);
              }
            } else {
              // 高校号 & 企业号
              if (this.userType == 1) {
                if (this.personalCenterData.certification_type == 2) {
                  this.facultySubjectShow = true;
                  this.facultyAchievementShow = true;
                  this.facultyTeacherShow = true;
                  this.interactShow = true;
                  // 校招
                  this.recruitShow = true;
                  this.getCur(5);
                } else {
                  this.recommendShow = true;
                  this.videoShow = true;
                  this.productShow = true;
                  this.circleShow = true;
                  this.interactShow = true;
                  // 校招
                  this.recruitShow = true;
                  this.getCur(0);
                }
              }
              if (this.userType == 2) {
                this.recommendShow = true;
                this.videoShow = true;
                this.circleShow = true;
                this.interactShow = true;
                // 答疑
                if(this.personalCenterData.is_open_qa){
                  this.answerShow = true;
                }
                this.getCur(0);
              }
            }

            document.title = this.personalCenterData.nickname || this.personalCenterData.username;

            this.wxshare.share({
              title: `分享 ${this.personalCenterData.nickname || this.personalCenterData.username}的主页`,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.personalCenterData.avatar,
            })
          }
        })
      },

      courselist(data) {
        if (data < 0) {
          this.courseShow = false;
        } else {
          this.courseShow = true;
        }
      },

      getCur(tab) {
        this.cur = sessionStorage.getItem('cur') || tab;
      },

      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },

      getTopPost() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.topPost = true;
        } else {
          this.topPost = false;
        }
      },

      getTopBtn() {
        window.scroll(0, 0);
      },
    },
  }
</script>

<style lang="css" scoped>
  .content {
    height: 50rem;
    background-size: 100% 21rem;
    background-repeat: no-repeat;
    object-fit: cover;
    padding-top: 18rem;
  }

  .introCon {
    background-color: #F7F8F8;
    border-radius: 2rem 2rem 0 0;
    height: 50rem;
  }

  .information {
    box-sizing: border-box;
    padding: 0 1.5rem 1rem 1.5rem;
    background-color: #FFFFFF;
    border-radius: 2rem 2rem 0 0;
  }

  .topInfo {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

  }

  .userHeader {
    width: 7.4rem;
    height: 7.4rem;
    border-radius: 50%;
    margin-top: -2.5rem;
    border: .2rem solid #FFFFFF;
  }

  .uesrHotData {
    position: relative;
    box-sizing: border-box;
    width: 9.5rem;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: .7rem;
  }

  .focusOn {
    border-left: .05rem solid #EBEEF5;
    border-right: .05rem solid #EBEEF5;
  }

  .dataName {
    font-size: 1.2rem;
    color: #A2A6AA;
  }

  .dataNum {
    font-size: 1.4rem;
    color: #1D2023;
  }

  .conInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 2.2rem;
  }

  .userName {
    font-size: 2rem;
    font-weight: 600;
  }

  .attentionBtn {
    position: relative;
    width: 6.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    color: #F7443F;
    border: .1rem solid #F7443F;
    border-radius: 2.5rem;
    font-size: 1.2rem;
  }

  .bottomInfo {}

  .userAccount {
    display: flex;
    align-items: center;
    margin-top: .6rem;
  }

  .userAccount img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: .4rem;
    margin-top: .1rem;
  }

  .userAccount p {
    font-size: 1.2rem;
    color: #1D2023;
  }

  .userIntroduce {
    margin-top: .6rem;
    font-size: 1.2rem;
    color: #808598;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  
  .relationCon {
    display: inline-block;
  }
  
  .userRelation {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    margin-top: .65rem;
    padding: .5rem .75rem;
    background-color: #F5F5F7;
    border-radius: .5rem;
  }
  
  .userRelation img {
    width: 1.45rem;
    height: 1.45rem;
    margin-right: .5rem;
  }
  
  .relationTxt {
    color: #6E7A93;
  }
  
  .relationNum {
    margin-left: .5rem;
    color: #44A6F0;
  }

  .informationMod {
    box-sizing: border-box;
    margin-top: 1rem;
  }

  .tabTilte {
    box-sizing: border-box;
    padding: 0 1.5rem;
    width: 100%;
    height: 4.4rem;
    display: flex;
    background-color: #FFFFFF;
    border-bottom: .05rem solid #C0C4CC;
    
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
    text-decoration: none;
  }

  .tabMod {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-right: 2rem;
    font-size: 1.6rem;
    color: #808598;
  }

  .active {
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
  }

  .active:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: .2rem;
    background-color: red;
    border-radius: .6rem;
    z-index: 1;
  }

  .tabContent {
    height: 30rem;
    background-color: #FFFFFF;
  }

  .callAppIcon {
    position: fixed;
    right: 0;
    bottom: 10.6rem;
    z-index: 10;
  }

  .callAppIcon img {
    width: 11.1rem;
    height: 3.35rem;
  }

  .topIcon {
    position: fixed;
    right: 1.1rem;
    bottom: 3rem;
    z-index: 11;
  }

  .topIcon img {
    width: auto;
    height: 4.15rem;
  }
</style>
